import { BarChart } from '@mui/x-charts/BarChart'
import { Paper, CircularProgress, Box } from '@mui/material'
import { useGetCourtesyChartQuery } from 'store/dashboard'
import ChartTitle from './ChartTitle'
import NoDataAvailable from './NoDataAvailable'
import { useTimeRange } from './TimeRangeContext'
import { barChartSlotProps, chartSx } from './chartDefaults'

interface Props {
  memberTiers?: string
}

const CourtesyChart = ({ memberTiers }: Props) => {
  const { startDate, endDate } = useTimeRange()

  const { data, isLoading, isError, refetch, isFetching } = useGetCourtesyChartQuery({
    startDate,
    endDate,
    memberTiers: memberTiers || undefined
  })

  const hasData = (data?.categories ?? []).length > 0 && (data?.series ?? []).length > 0

  return (
    <Paper
      sx={{
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        boxShadow: 'none'
      }}
      elevation={0}
    >
      <ChartTitle tooltip='The number of courtesy car bookings by car model'>Courtesy</ChartTitle>

      {isLoading || isFetching ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <CircularProgress />
        </Box>
      ) : isError ? (
        <NoDataAvailable variant='error' onRefresh={refetch} />
      ) : !data ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : !hasData ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : (
        <Box sx={{ width: '100%', height: 300 }}>
          <BarChart
            xAxis={[
              {
                scaleType: 'band',
                data: data.categories ?? [],
                label: 'Car Model'
              }
            ]}
            yAxis={[{ tickMinStep: 1 }]}
            series={(data.series ?? []).map((s) => ({
              label: s.label,
              data: s.data ?? [],
              color: s.color
            }))}
            height={300}
            slotProps={barChartSlotProps}
            sx={chartSx}
          />
        </Box>
      )}
    </Paper>
  )
}

export default CourtesyChart
